import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import {
  listCostSheetVersions,
  ListCostSheetVersionsResponse,
} from "../http/surveyEndpoints";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

// Keyed under "survey-endpoints" so useSurveyEndpoints' invalidateAll (fired
// after a cost-sheet import) also refreshes the version list.
const useCostSheetVersions = (
  endpointId: string,
  submissionId: string,
  enabled: boolean
): UseQueryResult<ListCostSheetVersionsResponse, unknown> => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);
  return useQuery(
    ["survey-endpoints", "cost-sheet-versions", endpointId, submissionId],
    async () =>
      listCostSheetVersions(
        await getAuthTokenBlocking(getToken, relogin),
        endpointId,
        submissionId
      ),
    { enabled }
  );
};

export default useCostSheetVersions;
